/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cn from 'classnames';
import { Box } from '@vital-ui/react-utils';
import { RadioContext } from './RadioContext';
/**
 * @render react
 * @name Radio
 * @description Group of radio buttons
 * @example
 * <RadioGroup name="color" selectedValue={value} onChange={set}>
 *        <Radio label="red" value="red" />
 *        <Radio label="blue" value="blue" />
 *        <Radio label="yellow" value="yellow" />
 *      </RadioGroup>
 */
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (value) {
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }
    RadioGroup.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, onChange = _a.onChange, style = _a.style, className = _a.className, name = _a.name, props = __rest(_a, ["disabled", "onChange", "style", "className", "name"]);
        return (React.createElement(Box, __assign({ style: style, className: cn('vital__radio-group', className) }, props),
            React.createElement(RadioContext.Provider, { value: {
                    name: name,
                    disabled: this.props.disabled,
                    seletedValue: this.props.selectedValue,
                    onChange: this.handleChange,
                } }, this.props.children)));
    };
    RadioGroup.defaultProps = {
        onChange: function () { },
        disabled: false,
    };
    return RadioGroup;
}(React.Component));
export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map